/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_tagRequest = {
    programme_ids: Array<number>;
    tag_color: api_tagRequest.tag_color;
    tag_description?: string;
    tag_name: string;
};
export namespace api_tagRequest {
    export enum tag_color {
        GREY = 'grey',
        GREEN = 'green',
        TEAL = 'teal',
        BLUE = 'blue',
        PURPLE = 'purple',
        MAGENTA = 'magenta',
        RED = 'red',
        ORANGE = 'orange',
        YELLOW = 'yellow',
    }
}

